import { DatePicker } from '@mui/x-date-pickers';
import React, { useEffect, useState } from 'react';
import { Button } from '../../../../components';
import config, { axiosInstance } from '../../../../_config/global';
import moment from 'moment';
import { useStateReducer } from '../../../../hooks';
import { reportingDataService } from '../../../reports/services';
import {
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import ReportStatusEnum from '../../../../enums/ReportStatusEnum';
import { hideAlert, showAlert } from '../../../../components/alert/Alert';
import { AlertTypeEnum } from '../../../../enums';
export interface ReportModel {
  _id: string;
  _created: Date;
  fromDate: Date;
  toDate: Date;
  s3Link: string;
  processingStatus: string;
  requestingUser: string;
  s3Key: string;
  fileName: string;
}

export interface Cookie {
  _id: string;
  token: string;
}

export default function PartnerDailyReport() {
  const [state, setState] = useStateReducer({
    exportDateFrom: moment(new Date(), config.dateFormat).subtract(30, 'days'),
    exportDateTo: moment(new Date(), config.dateFormat),
    userReports: []
  });
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedReport, setSelectedReport] = useState<ReportModel | null>(
    null
  );
  function handleDeleteOpen(id: string) {
    const selectedRep = state.userReports.filter(
      (rep: ReportModel) => rep._id === id
    )[0];
    setSelectedReport(selectedRep);
    setOpenDeleteDialog(true);
    return;
  }

  function handleDeleteClose() {
    setOpenDeleteDialog(false);
  }

  async function handleDailyExport(
    e: React.MouseEventHandler<HTMLButtonElement>
  ) {
    if (state.exportDateFrom && state.exportDateTo) {
      const requestedReport =
        await reportingDataService.getDailyPartnerRevenueShareByCode(
          state.exportDateFrom,
          state.exportDateTo
        );

      if (requestedReport.data.success === false && requestedReport.data.message) {
        showAlert({
          content: requestedReport.data.message,
          options: {
            actions: [
              {
                text: 'Okay',
                onClick: hideAlert,
                primary: true
              }
            ],
            type: AlertTypeEnum.Error
          }
        });
      } else if (
        requestedReport.data.success == true &&
        requestedReport.data.data.processingStatus ===
          ReportStatusEnum.Requested
      ) {
        showAlert({
          content:
            'Report has been requested successfully. Please check back in a few minutes to download the report.',
          options: {
            actions: [
              {
                text: 'Okay',
                onClick: hideAlert,
                primary: true
              }
            ],
            type: AlertTypeEnum.Info
          }
        });
      }
    }
  }

  async function downloadReport(_id: string, fileName: string) {
    try {
      await axiosInstance
        .get(`${config.endpoints.reports.fetchFileById}${_id}`)
        .then((val) => {
          // Convert binary array to base64 string
          const uint8Array = new Uint8Array(val.data.data.data);
          const blob = new Blob([uint8Array], { type: val.data.ContentType });

          // Create a download link
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);

          // Append the link to the body
          document.body.appendChild(link);

          // Trigger the download
          link.click();

          // Clean up the link
          document.body.removeChild(link);
        })
        .catch((err) => {
          showAlert({
            content:
              'Failed downloading report. Please try again later, or contact support.',
            options: {
              actions: [
                {
                  text: 'Okay',
                  onClick: hideAlert,
                  primary: true
                }
              ],
              type: AlertTypeEnum.Error
            }
          });
          console.log(JSON.stringify(err));
        });
    } catch (err) {
      console.log(JSON.stringify(err));
    }
  }

  async function deleteReport(_id: string) {
    try {
      await axiosInstance
        .put(`${config.endpoints.reports.deleteFileById}${_id}`)
        .then((val) => {
          fetchUserReports();
        })
        .catch((err) => {
          console.log('err request', err);
        });
    } catch (err) {
      console.log('err', JSON.stringify(err));
    }
    setOpenDeleteDialog(false);
  }

  const fetchUserReports = async () => {
    const { data: reports } = await axiosInstance.get(
      `${config.endpoints.reports.getUserReports}`,
      {}
    );
    setState({
      userReports: reports.data
    });
  };

  useEffect(() => {
    fetchUserReports();
  }, []);

  return (
    <div className='order-item'>
      <div className='export-csv'>
        <div>
          <DatePicker
            label='From'
            className='date-selector-partner'
            value={state.exportDateFrom}
            onChange={(date: Date | null) => {
              setState({ exportDateFrom: date });
            }}
          />
          <DatePicker
            label='To'
            className='date-selector-partner'
            minDate={state.exportDateFrom}
            value={state.exportDateTo}
            onChange={(date: Date | null) => {
              setState({ exportDateTo: date });
            }}
          />
        </div>

        <div>
          <Button
            className='category-option export-button'
            text='Request Daily CSV Report'
            primary
            raised
            onClick={handleDailyExport}
          ></Button>
          <Button
            className='category-option export-button'
            text='Refresh Reports'
            primary
            raised
            onClick={fetchUserReports}
          ></Button>
        </div>
      </div>

      <div>
        <Grid container spacing={2}>
          {state.userReports &&
            state.userReports.length > 0 &&
            state.userReports.map((report: ReportModel) => {
              return (
                <div key={report._id} style={{ margin: 10 }}>
                  <Grid item xs={12}>
                    <Card>
                      <CardContent>
                        <Typography
                          sx={{ fontSize: 14 }}
                          color='text.secondary'
                          gutterBottom
                        >
                          Requested Date :{' '}
                          {new Date(report._created).toLocaleDateString()}
                        </Typography>
                        <Typography
                          sx={{ fontSize: 14 }}
                          color='text.secondary'
                          gutterBottom
                        >
                          Date Range :{' '}
                          {new Date(report.fromDate).toLocaleDateString()} -{' '}
                          {new Date(report.toDate).toLocaleDateString()}
                        </Typography>
                        <Typography
                          sx={{ fontSize: 14 }}
                          color='text.secondary'
                          gutterBottom
                        >
                          Report Status : {report.processingStatus}
                        </Typography>
                        <Typography
                          sx={{ fontSize: 14 }}
                          color='text.secondary'
                          gutterBottom
                        >
                          {report.processingStatus
                            ? 'Available for download'
                            : 'Not Available'}
                        </Typography>
                      </CardContent>
                      <CardActions>
                        <Button
                          onClick={() =>
                            downloadReport(report._id, report.fileName)
                          }
                          text='Download'
                          raised
                          disabled={
                            report.processingStatus !== ReportStatusEnum.Done
                          }
                        ></Button>
                        <Button
                          onClick={() => handleDeleteOpen(report._id)}
                          text='Delete'
                          raised
                          disabled={
                            report.processingStatus !== ReportStatusEnum.Done
                          }
                        ></Button>
                      </CardActions>
                    </Card>
                  </Grid>
                </div>
              );
            })}
        </Grid>
      </div>

      <Dialog
        open={openDeleteDialog}
        onClose={handleDeleteClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Are you sure you want to delete this report? This action is
            irreversible, and you will have to request to run the report again
            to have access to the data.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteClose} text='Disagree'></Button>
          <Button
            onClick={() => deleteReport(selectedReport?._id!)}
            text='Agree'
          ></Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
